import { Link, useLocation } from "react-router-dom";
import { LogOut, Radio } from "lucide-react";
import { useViewerAuth } from "@/context/ViewerAuthContext";
import { isSharedYsvAdmin } from "../context/adminSessionState";

export const Header = () => {
  const location = useLocation();
  const { user, logout } = useViewerAuth();
  const links = [
    { to: user ? "/games" : "/", label: "Live Games" },
    { to: "/library", label: "Library" },
    ...(isSharedYsvAdmin(user)
      ? [{ to: "/admin/dashboard", label: "Admin" }]
      : []),
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-white/10 bg-[#0A0A0A]/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-4 sm:px-6">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center bg-[#007AFF]">
            <Radio className="h-5 w-5 text-white" />
          </span>
          <span className="font-display text-xl font-black uppercase tracking-tighter text-white sm:text-2xl">
            YSV<span className="text-[#007AFF]">Live</span>
          </span>
        </Link>
        <nav className="flex items-center gap-1">
          {links.map((l) => {
            const active =
              l.label === "Live Games"
                ? location.pathname === "/" || location.pathname.startsWith("/games")
                : location.pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`hidden px-2 py-2 font-display text-xs font-bold uppercase tracking-wider transition-colors sm:inline-flex sm:px-4 sm:text-sm ${
                  active ? "text-white" : "text-white/50 hover:text-white"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
          {user ? (
            <button
              type="button"
              onClick={logout}
              data-testid="viewer-sign-out"
              className="ml-1 inline-flex items-center gap-2 border border-white/15 px-3 py-2 font-display text-xs font-bold uppercase tracking-wider text-white/70 transition-colors hover:border-white/40 hover:text-white sm:ml-2 sm:px-4 sm:text-sm"
            >
              <LogOut className="h-4 w-4" /> Sign Out
            </button>
          ) : (
            <Link
              to="/sign-in"
              data-testid="header-sign-in"
              className="ml-2 bg-[#007AFF] px-4 py-2.5 font-display text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#0062cc] focus:outline-none focus:ring-2 focus:ring-white sm:px-6 sm:text-sm"
            >
              Sign In
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};
